import React, { Component } from 'react'
import styled from 'styled-components';
import BlockTopBar from 'components/commons/BlockTopBar';
import Tile from './Tile';
import GlobalStyle from 'stylecomponents/globalstyle';
import GLOBAL from 'nonnglobal';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

const BigBlockContainer = GlobalStyle.BasicBlock.extend`
  min-height: 640px;
  margin-bottom: ${GlobalStyle.ViewSpace}px;
`;

const Tiles = styled.div`
  display: grid;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  cursor: pointer;
`

class BigBlock extends Component {

  render() {
    const {
      title,
      data,
      state,
      isLoading,
      isError,
    } = this.props;
    return (
      <BigBlockContainer>
        <BlockTopBar title={title} num={data.num} state={state} />
        <Tiles>
          {data.map((item, index) => {

            if (index >= 6){
              return null;
            }

            const {
              gameid,
              gamename = '',
              idximg,
              productid,
              thumbimg,
              productname = '',
            } = item;

            let key, _title, imgRsc, params, stateName;

            if(state === CupoyRouter.STATES.GAME) {
              key = gameid;
              _title = gamename;
              params = { gameid };
              imgRsc = `${GLOBAL.imgSrcRootURL}/gameimgs/${gameid}/${idximg}`;
              stateName = CupoyRouter.STATES.GAME_TEMP_TRANSACTION;

            } else {
              key = productid;
              _title = productname;
              params = { id: productid };
              imgRsc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg);
              stateName = GLOBAL.getProductRouterName(item);

            }

            return (
              <Tile
                key={key}
                title={_title.trim()}
                img={imgRsc}
                stateName={stateName}
                params={params}
              />
            );
          })}
        </Tiles>
        {
          isLoading && (
            <GlobalStyle.LoadingContainer>
                <GlobalStyle.Spin />
            </GlobalStyle.LoadingContainer>
          )
        }
        {
          isError && (
            <GlobalStyle.ErrorContainer>
                <GlobalStyle.ErrorContainerTitle>
                    發生錯誤
                </GlobalStyle.ErrorContainerTitle>
                <GlobalStyle.ErrorContainerDesription>
                    無法取得列表，請重新整理後再嘗試。
                </GlobalStyle.ErrorContainerDesription>
            </GlobalStyle.ErrorContainer>
          )
        }
      </BigBlockContainer>
    )
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    gameSeverListById: state.game.gameSeverListById,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(BigBlock);